import { Component, OnInit } from '@angular/core';
import { VentasService } from '../../../services/ventas.service';
import { ObrasService } from '../../../services/obras.service';
import { ProveedoresService } from '../../../services/proveedores.service';

declare var moment;

@Component({
  selector: 'app-tabla-servicios',
  templateUrl: './tabla-servicios.component.html',
  styleUrls: ['./tabla-servicios.component.scss']
})
export class TablaServiciosComponent implements OnInit {
    
  //Models
    public obras: any [] = [];
    public proveedores: any [] = [];
    public ventas: any [] = [];
    
    //Filtros
    public obraSelected: any = {};
    public proveedorSelected: any = {};
    public fecha_inicio: any = null;
    public fecha_termino: any = null;
    
    //Helpers
    public loading: boolean = false;
    public loading_obras: boolean = false;
    public loading_proveedores: boolean = false;
    public obra: any = {};
    public proveedor: any = {};
    public fechaInicioInicializada: boolean = false;
    public fechaTerminoInicializada: boolean = false;
    
    //paginacion
    public paginate: any = {};
    public page: number = 1;

    constructor(
      private ventasService: VentasService,
      private obrasService: ObrasService,
      private proveedoresService: ProveedoresService
    ) {
        
    }

    ngOnInit() {
      this.loadObras();
      this.loadProveedores();  
      this.configurarFechasDefault();
      
      //El componente datepicker toma 200 ms en cargar las fechas, por lo cual hay que esperar a que pase este tiempo para cargar las ventas con su valor default
      //Este código evita que se hagan multiples peticiones cuando se inicializa el componente
      /* setTimeout( () => {
        this.cargarVentas();
      }, 400); */
    }

    private configurarFechasDefault(){
      let unMesAntes = moment().add(-1,'M').format("YYYY-MM-DD");
      let now = moment().format("YYYY-MM-DD");
      this.fecha_inicio = unMesAntes;
      this.fecha_termino = now;
    }

    private cargarVentas(){
      //Se requiere que ya este inicializado el datepicker para consultar las ventas la primera vez
      if(!this.fechaTerminoInicializada || !this.fechaInicioInicializada){
        return;
      }

      this.loading = true;
      let filtros = this.obtenerFiltros();
      
      this.ventasService.listarVentas(filtros)
      .subscribe(
        (response)=> {
          this.loading = false;
          let content = response.json().content;
          this.ventas = content.data;
          this.setupPagination(content);
        },
        (error) => {
          this.loading = false;
        }
        );
      }
      
      private obtenerFiltros(){
        let filtros = {
          page: this.page,
          id_emisor: (this.obraSelected && this.obraSelected.idObras) ?  this.obraSelected.idObras : null,
          id_cliente: (this.proveedorSelected && this.proveedorSelected.idProveedores) ?  
              this.proveedorSelected.idProveedores : null,
          fecha_inicio: this.fecha_inicio,
          fecha_termino: this.fecha_termino
        };
        
        return filtros;
      }

    private loadObras(){
      this.loading_obras = true;
      this.obrasService.getObratoSelect('')
      .subscribe((response) => {
          this.obras = response.json().content;
          this.loading_obras = false;
      },error=>{
          alert("ERROR: "+JSON.stringify(error));
          this.loading_obras = false;
      });
    }

    private loadProveedores(){
      this.loading_proveedores = true;
      this.proveedoresService.getProveedorestoSelect()
      .subscribe(response => {
          let content = response.json().content;
          this.proveedores = content.proveedores;
          this.loading_proveedores = false;
      },error=>{
          alert("ERROR: "+JSON.stringify(error));
          this.loading_proveedores = false;
      });
    }

    public seleccionaObra(event){
      this.obraSelected = event;
    }

    public seleccionaProveedor($event){
        this.proveedorSelected = $event;
    }

    public seleccionarFechaInicio(event){
      this.fecha_inicio=event;
      this.fechaInicioInicializada = true;
      this.cargarVentas();
    }

    public seleccionarFechaTermino(event){
      this.fecha_termino=event;
      this.fechaTerminoInicializada = true;
      this.cargarVentas();
    }

    /**
     * 
     * Paginación
     */
    private setupPagination(content){
      this.paginate.first_item = content.from;
      this.paginate.last_item = content.to;
      this.paginate.last_page = content.last_page;
      this.paginate.per_page = content.per_page;
      this.paginate.total_items = content.total;
      this.paginate.current_page = content.current_page;
  
      this.paginate.pages = [];
      for(let i = 1; i <= this.paginate.last_page; i++){
        this.paginate.pages.push({
          'number': i,
          'label': i
        });
      }
    }

    public pageChanged(event: any): void {
      if(event.page !== undefined && event.page != this.page){  
          this.page = event.page;
      }

      this.cargarVentas();
    }
}


// WEBPACK FOOTER //
// ./src/app/components/modulo-servicios/tabla-servicios/tabla-servicios.component.ts